<template>
  <div :class="type" class="w-full p-4 rounded-sm my-2">
    <slot />
  </div>
</template>
<script>
export default {
  name: "BaseAlert",
  props: {
    type: {
      type: String,
      required: true
    }
  }
};
</script>
<style lang="postcss" scoped>
.warning,
.warning * {
  background-color: #fb8c00;
  color: white;
}
.info,
.info * {
  background-color: blue;
  color: white;
}
.success,
.success * {
  background-color: #4caf50;
  color: white;
}
.error,
.error * {
  background-color: #f44336;
  color: white;
}
</style>
